import type {AfriexProcessor} from '@/types';

export class ProcessorValidator {
  constructor(private request: Partial<AfriexProcessor>) {}

  private throwErrorMessage(errorMessage: string) {
    throw new Error(errorMessage);
  }

  private validateName() {
    if (!this.request?.name) {
      this.throwErrorMessage('No processor name provided');
    }
    return this;
  }

  private validateCode() {
    if (!this.request?.code) {
      this.throwErrorMessage('No processor code provided');
    }
    return this;
  }

  private validate() {
    this.validateName();
    this.validateCode();
  }

  value(): AfriexProcessor {
    this.validate();
    return this.request as AfriexProcessor;
  }
}
